import { useState } from 'react';
import { Content, Name, Middle, Items } from './list.styled';

// name === '' = w/o inset
export const List = (props) => {
  const { name, items, changePermission } = props;
  const [open, setOpen] = useState(!name);

  const toggle = () => {
    setOpen((val) => !val);
  };

  let cnt = 0;
  items.forEach((element) => {
    if (element.is_allowed) {
      cnt++;
    }
  });
  let all = cnt === items.length,
    none = cnt === 0;

  const disabled = () => {};

  const middle = !all && !none;
  const cl = middle ? 'gray' : '';
  const cl1 = name ? 'sub' : '';

  return (
    <Content>
      {name && (
        <Name onClick={toggle} className={cl}>
          {middle ? <Middle /> : <input type="checkbox" name={name} onChange={disabled} checked={all} />}
          <span>{name}</span>
        </Name>
      )}
      {open && (
        <Items className={cl1}>
          {items.map((el, idx) => (
            <label key={idx}>
              <input onChange={(e) => changePermission(e, el.permission_id)} type="checkbox" name={el.permission_id} checked={el.is_allowed} />
              <span>{el.permission_description}</span>
            </label>
          ))}
        </Items>
      )}
    </Content>
  );
};
